
import { useMemo } from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';

import { PLAY_INFO_ID } from '@/const/mission';
import { IBot, IEvents } from '@/interface';
import { handleExportEvents } from '@/pages/mission/info/card/event/customEvent/util/exportEvent';
import { transformObjectDeep } from '@/utils/tans/object';

import styles from './index.module.less';

export default function DiffJsonView(props: {
  leftData: IEvents[],
  rightData: IEvents[],
  isEvent?: boolean;
  leftTitle: string;
  rightTitle: string;
  bots: {
    draftBots: IBot[];
    releaseBots: IBot[];
    playerInfo: {
      name: string;
    };
  }
}) {
  const { leftData = [], rightData = [], isEvent = false, leftTitle = '', rightTitle = '', bots } = props;

  const newStyles = {
    variables: {
      dark: {
        diffViewerBackground: '#2e303c',
        diffViewerColor: 'black',
        addedBackground: '#044B53',
        addedColor: 'white',
        removedBackground: '#632F34',
        removedColor: 'white',
        wordAddedBackground: '#055d67',
        wordRemovedBackground: '#7d383f',
        addedGutterBackground: '#034148',
        removedGutterBackground: '#632b30',
        gutterBackground: '#2c2f3a',
        gutterBackgroundDark: '#262933',
        highlightBackground: '#2a3967',
        highlightGutterBackground: '#2d4077',
        codeFoldGutterBackground: '#21232b',
        codeFoldBackground: '#262831',
        emptyLineBackground: '#363946',
        gutterColor: '#464c67',
        addedGutterColor: '#8c8c8c',
        removedGutterColor: '#8c8c8c',
        codeFoldContentColor: '#555a7b',
        diffViewerTitleBackground: '#2f323e',
        diffViewerTitleColor: '#555a7b',
        diffViewerTitleBorderColor: '#353846',
      },
    },
    line: {
      padding: '10px 2px',
      '&:hover': {
        background: 'grey',
      },
    },
    contentText: {
      width: '390px',
    },
  };

  const getBots = (bots: IBot[]) => bots?.map(e => ({
    id: e?.id,
    name: e?.botDetail?.name || '未命名',
    url: e?.avatar?.url?.url || '',
  })) || [];

  const { leftJSON, rightJSON } = useMemo(() => {
    const draftBots = getBots(bots?.draftBots);
    const releaseBots = getBots(bots?.releaseBots);

    if (isEvent) {
      const left = handleExportEvents((transformObjectDeep({ data: leftData }, 'camel') as { data: IEvents[] })?.data, [], [...releaseBots, {
        name: bots?.playerInfo?.name || '未命名',
        id: PLAY_INFO_ID,
        url: '',
      }], []);

      const right = handleExportEvents((transformObjectDeep({ data: rightData }, 'camel') as { data: IEvents[] })?.data, [], [...draftBots, {
        name: bots?.playerInfo?.name || '未命名',
        id: PLAY_INFO_ID,
        url: '',
      }], []);
      return {
        leftJSON: JSON.stringify(left, undefined, 4),
        rightJSON: JSON.stringify(right, undefined, 4),
      };
    }
    return {
      leftJSON: JSON.stringify(leftData, undefined, 4),
      rightJSON: JSON.stringify(rightData, undefined, 4),
    };
  }, [leftData, rightData, isEvent, bots?.draftBots, bots?.releaseBots, bots?.playerInfo?.name]);

  return (
    <div className={styles.diffView}>
      <ReactDiffViewer
        oldValue={leftJSON}
        newValue={rightJSON}
        splitView={true}
        compareMethod={DiffMethod.WORDS}
        styles={newStyles}
        leftTitle={leftTitle}
        rightTitle={rightTitle}
      />
    </div>
  );
}
